<template>
    <div>
        <v-card v-for="product in products" :key="product.id" class="d-flex mt-4 z-no-focus" height="65px" @click="showAdditionalProduct(product)">
            <v-auto-img :src="product.imagekey" width="100px" height="65px" max-width="100px" max-height="65px" style="border-bottom-left-radius: inherit; border-top-right-radius: 0">
                <svg height="55px" width="55px" v-if="countForProduct(product) > 0 && showAddedBanner">
                    <polygon points="0,0 55,0 0,55" :style="{fill: $root.colorToHex('primary')}" />
                    <text style="font-size:12px" x="-23" y="35" width="40" height="20" transform="rotate(-45)" :fill="$root.colorToHex('primarytext')">{{$translate('Added').toUpperCase()}}</text>
                </svg>
            </v-auto-img>

            <div class="flex-grow-1 px-2 z-min-width-0">
                <div><b>{{product.name}}</b></div>
                <div style="height: 43px;overflow: hidden" v-html="stripHtml(product.description)"></div>
            </div>
            <div class="d-flex px-2 flex-column">
                <div class="primary--text font-weight-bold text-no-wrap align-self-center">{{getPrice(product)}}</div>
                <div class="align-self-end"><zoezi-button thin :text="$translate(buyButtonText)" @click.stop="buyButtonClick(product)" />
                </div>
            </div>
        </v-card>

        <product-dialog v-model="showProductDialog" :product="showingProduct" :show-count="false" :show-buy-button="true" :basket="totalBasket" v-if="showingProduct" @buy="buy($event, showingProduct)" />
    </div>
</template>

<script>
import {stripHtml, formatPrice} from '../util.js'
import ProductDialog from '../components/ProductDialog.vue'
import ZoeziButton from '../views/Button.vue'
export default {
    name: 'zoezi-additional-product-list',

    props: {
        products: {},
        basket: {},
        totalBasket: {},
        showAddedBanner: {
            type: Boolean
        },
        buyEvent: {
            type: Boolean
        },
        buyButtonText: {
            type: String,
            default: 'Buy'
        }
    },

    components: {
        ProductDialog,
        ZoeziButton
    },

    data: () => ({
        showProductDialog: false,
        showingProduct: null
    }),

    methods: {
        showAdditionalProduct(product) {
            this.showingProduct = product;
            this.showProductDialog = true;
        },
        countForProduct(product) {
            let count = 0;
            if (this.basket) {
                this.basket[product.id].forEach(bi => count += bi.count);
            }
            return count;
        },
        stripHtml,
        buyButtonClick(product) {
            if (this.buyEvent) {
                this.$emit('buy', product)
                return;
            }

            if (product.variants) {
                this.showAdditionalProduct(product);
            } else {
                this.buy({count: 1, variant: null}, product);
            }
        },
        buy(item, product) {
            let count = item.count;
            let variant = item.variant;
            let b = this.basket[product.id]
            let i = b.find(x => x.variant == variant);

            let stock = item.variant == null ? product.stock : product.variants.find(x => x.name == item.variant).stock;
            if (stock != null && this.totalBasket) {
                let bi = this.totalBasket.find(i => i.product_id == product.id && variant == i.variant);
                if (bi && bi.count) {
                    stock -= bi.count;
                }
                stock = Math.max(0, stock);
            }

            if (stock != null && count > stock) {
                let text = stock > 0 ? this.$translate('There is only {0} of this product in stock').format(stock) : this.$translate('There are no products left in stock');
                this.$store.commit('showSnackBar', {text});
            } else {
                if (i) {
                    i.count += count;
                } else {
                    b.push({count, variant});
                }
            }
        },
        getPrice(product) {
            let res = formatPrice(product.price);
            if (!product.priceType || product.priceType == 'OneTime') {
                return res;
            } else {
                res += ' per ' + this.$translate(product.priceType).toLowerCase();
                return res;
            }
        }
    }
}
</script>